import { Box } from '@mui/material';
import React, { useState } from 'react';
import TabPanel from '../Common/Layout/TabPanel';
import FtseList from './FtseList';
import FtseFxList from './FtseFxList';
import Equalizer from '@mui/icons-material/Equalizer';
import Piechart from '@mui/icons-material/PieChart';
import CustomAppBar from '../Common/Layout/CustomAppBar';

const FtseInfoWrapper: React.FunctionComponent = () => {
  const [value, setValue] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <CustomAppBar
        value={value}
        handleChange={(_, newValue) => setValue(newValue)}
        type="first"
        tabProps={[
          {
            id: 'ftse',
            title: 'FTSE',
            icon: Equalizer
          },
          {
            id: 'ftse-fx',
            title: 'FTSE FX',
            icon: Piechart
          }
        ]}
      />
      <Box>
        <TabPanel value={value} index={0}>
          <FtseList />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <FtseFxList />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default FtseInfoWrapper;
